import BrandLogo from "@/components/common/BrandLogo";
import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import Image from "next/image";

export default function LoginAside() {
  return (
    <section className="relative hidden lg:flex flex-col justify-between overflow-hidden bg-zinc-950 p-8 text-white lg:p-12">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <Image
          src="/Chandra-Sir.png"
          alt="Motivational Background"
          fill
          priority
          sizes="(max-width: 1024px) 100vw, 50vw"
          className="object-cover object-top opacity-100 transition-transform duration-1000 hover:scale-105"
        />
        {/* Cleaner overlay: less shadow, mostly just to keep the bottom text readable */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
      </div>

      <div className="relative z-10 flex h-full flex-col justify-between">
        {/* Top Section - Just the Back button */}
        <div className="flex justify-between items-start">
          <Link
            href="/"
            className="inline-flex items-center text-sm font-medium text-white opacity-80 transition-opacity hover:opacity-100 drop-shadow-md"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Link>
        </div>

        {/* Bottom Section - Text and Logo */}
        <div className="mt-auto flex flex-col">
          <div className="max-w-lg mb-8">
            <div className="mb-6 inline-flex items-center rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-xs font-medium text-white backdrop-blur-md shadow-sm">
              <span className="mr-2 flex h-2 w-2 rounded-full bg-emerald-400 animate-pulse"></span>
              Join the winning team
            </div>
            <h1 className="text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl drop-shadow-lg">
              Let's <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400 drop-shadow-sm">do it.</span>
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-zinc-100 drop-shadow-md">
Every call is an opportunity. Every conversation builds trust. Every site visit brings us closer to success. Make every call count. Go! crush your targets today!            </p>
          </div>

          {/* Logo at the bottom left corner */}
          <div className="flex items-center drop-shadow-md pt-4 border-t border-white/10">
            <Link href="/">
              <BrandLogo size="sm" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
